import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';

import { wrapAuthFetch } from 'util/api';

export const getBonus = createAction('GET_BONUS', async () => {
	const { status, data } = await wrapAuthFetch('user/credits');

	if (status !== 200) {
		return { data: {}, list: [] };
	}

	const bonusData = {};
	const list = data.data.map(item => {
		bonusData[item.id] = item;

		return item.id;
	});

	return { data: bonusData, list, remain: data.remain, total: data.total, used: data.used };
});

const reducer = {
	bonus: handleActions(
		{
			GET_BONUS_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_BONUS_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				list: action.payload.list,
				remain: action.payload.remain,
				total: action.payload.total,
				used: action.payload.used,
				loading: false,
			}),
		},
		{
			data: {},
			list: [],
			loading: false,
			remain: 0,
			total: 0,
			used: 0,
		},
	),
};

const selectBonus = createSelector(
	state => state.bonus.data,
	state => state.bonus.list,
	state => state.bonus.remain,
	state => state.bonus.total,
	state => state.bonus.used,
	(data, list, remain, total, used) => ({
		bonus: list.map(id => ({
			id,
			date: data[id].created_at.split(' ')[0].replace(/-/g, ' / '),
			record: data[id].description,
			count: data[id].is_redeem === 0 ? data[id].value : 0 - data[id].value,
			expiry: data[id].end_at === null ? '' : data[id].end_at.split(' ')[0],
		})),
		remain,
		total,
		used,
	}),
);

export const useBonus = () => useRedux(selectBonus);

export default { reducer };
